// extracted by mini-css-extract-plugin
export var printerCard = "_as-1";
export var printerCardConfigured = "_as-2";
export var printerCardError = "_as-3";
export var printerCardsContainer = "_as-0";
export var printerIcon = "_as-8";
export var printerIconConfigured = "_as-5";
export var printerIconContainer = "_as-4";
export var printerIconError = "_as-6";
export var printerIconUnconfigured = "_as-7";
export var workstationsTableCard = "_as-9";